import { createApp } from 'vue'

/** Import css in javascript
 * as encouraged in laravel and vite docs
 */
//import '/resources/sass/app.scss'

/**Setup all plugins */
import setupPlugins from '@src/plugins/setup'

/**Setup all libraries */
import setupLibs from '@src/libs/setup'

//import AppView from '@src/vue/App.vue'

const app = createApp(defineAsyncComponent(() => import('@src/vue/App.vue')))

setupPlugins(app)
setupLibs(app)

app.mount('#app')
